module.exports = __webpack_public_path__ + "img/077.10c0375a.png";